exports = module.exports = require("../../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".vux-modal-open{overflow:hidden;position:fixed;width:100%}.vux-modal-open-for-container{overflow:hidden!important}", "", {"version":3,"sources":["/opt/www/html/oa09/clients/ams/node_modules/vux/src/styles/vux-modal.css"],"names":[],"mappings":"AAAA,gBACE,gBAAiB,AACjB,eAAgB,AAChB,UAAY,CACb,AACD,8BACE,yBAA2B,CAC5B","file":"vux-modal.css","sourcesContent":[".vux-modal-open {\n  overflow: hidden;\n  position: fixed;\n  width: 100%;\n}\n.vux-modal-open-for-container {\n  overflow: hidden!important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vux/src/styles/vux-modal.css
// module id = 520
// module chunks = 52